
// tslint:disable: no-namespace

/** For audio description, press enter or tap the lower left of the screen.  */
export const PROMPT_AUDIO_DESCRIPTION = "inez_prompt_audio_description";
/** Duck Dash */
export const TITLE = "inez_title";
/** Play */
export const BUTTON_PLAY_HOVER = "inez_button_play_hover";
/** Set up */
export const BUTTON_SETUP_HOVER = "inez_button_setup_hover";
/** Dwell */
export const DWELL = "inez_dwell";
/** Turn Dwell On */
export const BUTTON_DWELL_HOVER_OFF = "inez_button_dwell_hover_off";
/** Dwell is On */
export const DWELL_ON = "inez_dwell_on";
/** Turn Dwell Off */
export const BUTTON_DWELL_HOVER_ON = "inez_button_dwell_hover_on";
/** Dwell is Off */
export const DWELL_OFF = "inez_dwell_off";
/** Info */
export const BUTTON_HELP_HOVER = "inez_button_help_hover";
/** Select "Play" to start the game. Select "Set up" to adjust the settings the way you like them. Select "Dwell On" to play using a head or eye tracking device. */
export const SPLASH_HELP = "inez_splash_help";
/** Settings */
export const BUTTON_SETTINGS_HOVER = "inez_button_settings_hover";
/** Matt, Jackie, and Inez - that's me! - wear helmets and purple jet packs with wings. We're hanging out in the cybersky with Digit, our cyber bird friend, and his duck friends. */
export const SPLASH_AUDIO_DESCRIPTION = "inez_splash_audio_description";
/** Use the tab key to explore. */
export const SPLASH_AUDIO_DESCRIPTION_TAB = "inez_splash_audio_description_tab";
/** We're the Cybersquad. I'm Jackie! */
export const INTRO_1 = "jackie_intro_1";
/** I'm Matt. */
export const INTRO_2 = "matt_intro_2";
/** and I'm Inez. */
export const INTRO_3 = "inez_intro_3";
/** The Northern Frontier ducks are migrating to their winter home, Restoria, and we're going to follow them!  */
export const INTRO_4 = "inez_intro_4";
/** We are wearing our purple jet packs with wings and helmets and flying in the cybersky with Digit and the ducks.  */
export const AUDIO_DESCRIPTION_1 = "inez_audio_description_1";
/** Ducks migrate or move from one region to another to find a warm place to live with plenty of good food and water. */
export const INTRO_5 = "jackie_intro_5";
/** The flock needs to avoid obstacles and manage their energy while migrating to Restoria.  */
export const INTRO_6 = "matt_intro_6";
/** Your mission is to work with the ducks to get to Restoria safely. */
export const INTRO_7 = "inez_intro_7";
/** But how can ducks fly such a long distance without getting tired or hungry?  */
export const INTRO_8 = "jackie_intro_8";
/** Let's tag along and find out! */
export const INTRO_9 = "matt_intro_9";
/** Skip intro */
export const BUTTON_SKIP_INTRO_HOVER = "matt_skip_intro_hover";
/** Adjust the settings the way you want them. When you're done, select the checkmark. */
export const SETTINGS_HELP = "inez_settings_help";
/** Reset all settings to default. */
export const BUTTON_RESET_HOVER = "inez_button_reset_hover";
/** Sound and Caption Settings */
export const SETTINGS_SOUND_TITLE = "inez_settings_sound_title";
/** Audio */
export const BUTTON_AUDIO_HOVER = "inez_button_audio_hover";
/** Use this to control volume for music, sounds, and voices. */
export const SETTINGS_AUDIO_HELP = "inez_settings_audio_help";
/** Music */
export const SETTINGS_MUSIC_HOVER = "inez_settings_music_hover";
/** Music Off */
export const SETTINGS_MUSIC_OFF = "inez_settings_music_off";
/** Level 1 Quietest */
export const SETTINGS_MUSIC_1 = "inez_settings_music_1";
/** Level 2, Medium */
export const SETTINGS_MUSIC_2 = "inez_settings_music_2";
/** Level 3, Louder */
export const SETTINGS_MUSIC_3 = "inez_settings_music_3";
/** Level 4, Loudest */
export const SETTINGS_MUSIC_4 = "inez_settings_music_4";
/** Sound Effects  */
export const SETTINGS_SFX_HOVER = "inez_settings_sfx_hover";
/** Sound Effects Off */
export const SETTINGS_SFX_OFF = "inez_settings_sfx_off";
/** Voice */
export const SETTINGS_VO_HOVER = "inez_settings_vo_hover";
/** Voice Off */
export const SETTINGS_VO_OFF = "inez_settings_vo_off";
/** Closed Captions */
export const SETTINGS_CC_HOVER = "inez_settings_cc_hover";
/** Use this to turn closed captions on or off. Captions let you read along with what we're saying. */
export const SETTINGS_CC_HELP = "inez_settings_cc_help";
/** Closed Captions On */
export const CC_ON = "inez_cc_on";
/** Closed Captions Off */
export const CC_OFF = "inez_cc_off";
/** Audio Description */
export const SETTINGS_AD_HOVER = "inez_settings_ad_hover";
/** Use this to turn audio descriptions on or off. */
export const SETTINGS_AD_HELP = "inez_settings_ad_help";
/** Audio Description On */
export const AD_ON = "inez_audio_description_on";
/** Audio Description Off */
export const AD_OFF = "inez_audio_description_off";
/** Use tab or space to move through the settings or to move to another settings page. Use the enter key to choose what you want to change. */
export const SETTINGS_SOUND_AUDIO_DESCRIPTION = "inez_settings_sound_audio_description";
/** Done */
export const SETTINGS_DONE = "inez_done";
/** Gameplay Settings */
export const SETTINGS_GAMEPLAY_TITLE = "inez_settings_gameplay_title";
/** Challenge Level */
export const SETTINGS_DIFFICULTY_HOVER = "inez_settings_difficulty_hover";
/** Use this to control how challenging the game is. */
export const SETTINGS_DIFFICULTY_HELP = "inez_settings_difficulty_help";
/** Adaptive, the game gets more or less challenging depending on how you play. */
export const SETTINGS_DIFFICULTY_ADAPTIVE = "inez_settings_difficulty_adaptive";
/** Challenge Level 1, starting level */
export const SETTINGS_DIFFICULTY_1 = "inez_settings_difficulty_1";
/** Challenge Level 2, more challenging */
export const SETTINGS_DIFFICULTY_2 = "inez_settings_difficulty_2";
/** Challenge Level 3, most challenging */
export const SETTINGS_DIFFICULTY_3 = "inez_settings_difficulty_3";
/** Flight Speed */
export const SETTINGS_SPEED_HOVER = "inez_settings_speed_hover";
/** Use this to control how fast the obstacles are moving. Speed 1 is slowest and 8 is fastest. */
export const SETTINGS_SPEED_HELP = "inez_settings_speed_help";
/** 1, slowest */
export const SETTINGS_SPEED_1 = "inez_settings_speed_1";
/** 2 */
export const SETTINGS_SPEED_2 = "inez_settings_speed_2";
/** 3 */
export const SETTINGS_SPEED_3 = "inez_settings_speed_3";
/** 4 */
export const SETTINGS_SPEED_4 = "inez_settings_speed_4";
/** 5 */
export const SETTINGS_SPEED_5 = "inez_settings_speed_5";
/** 6 */
export const SETTINGS_SPEED_6 = "inez_settings_speed_6";
/** 7 */
export const SETTINGS_SPEED_7 = "inez_settings_speed_7";
/** 8, fastest */
export const SETTINGS_SPEED_8 = "inez_settings_speed_8";
/** Display Settings */
export const SETTINGS_DISPLAY_TITLE = "inez_settings_display_title";
/** Text Size */
export const SETTINGS_TEXT_SIZE_HOVER = "inez_settings_text_size_hover";
/** Use this to control the size of the letters on your screen. */
export const SETTINGS_TEXT_SIZE_HELP = "inez_settings_text_size_help";
/** Text Size: Small */
export const SETTINGS_TEXT_SIZE_1 = "inez_settings_text_size_1";
/** Text Size: Medium */
export const SETTINGS_TEXT_SIZE_2 = "inez_settings_text_size_2";
/** Text Size: Large */
export const SETTINGS_TEXT_SIZE_3 = "inez_settings_text_size_3";
/** Color */
export const SETTINGS_COLOR_HOVER = "inez_settings_color_hover";
/** Change the color of pictures on your screen. */
export const SETTINGS_COLOR_HELP = "inez_settings_color_help";
/** Full Color */
export const SETTINGS_COLOR_1 = "inez_settings_color_1";
/** Black and White */
export const SETTINGS_COLOR_3 = "inez_settings_color_3";
/** Animations */
export const SETTINGS_ANIMATIONS_HOVER = "inez_settings_animations_hover";
/** Choose to have more or fewer things moving on your screen */
export const SETTINGS_ANIMATIONS_HELP = "inez_settings_animations_help";
/** Fewer Animations */
export const SETTINGS_ANIMATIONS_1 = "inez_settings_animations_1";
/** More Animations */
export const SETTINGS_ANIMATIONS_2 = "inez_settings_animations_2";
/** Button Size */
export const SETTINGS_BUTTON_SIZE_HOVER = "inez_settings_button_size_hover";
/** Choose the size of the buttons on your screen */
export const SETTINGS_BUTTON_SIZE_HELP = "inez_settings_button_size_help";
/** Small Buttons */
export const SETTINGS_BUTTON_SIZE_1 = "inez_settings_button_size_1";
/** Large Buttons */
export const SETTINGS_BUTTON_SIZE_2 = "inez_settings_button_size_2";
/** Text Color */
export const SETTINGS_TEXT_COLOR_HOVER = "inez_settings_text_color_hover";
/** Adjust the text color on your screen */
export const SETTINGS_TEXT_COLOR_HELP = "inez_settings_text_color_help";
/** Black Text */
export const SETTINGS_TEXT_COLOR_1 = "inez_settings_text_color_1";
/** White Text on Black Background */
export const SETTINGS_TEXT_COLOR_2 = "inez_settings_text_color_2";
/** Background Art */
export const SETTINGS_BACKGROUNDS_HOVER = "inez_settings_backgrounds_hover";
/** Turn the background picture on or off. */
export const SETTINGS_BACKGROUNDS_HELP = "inez_settings_backgrounds_help";
/** Background Art: Off */
export const SETTINGS_BACKGROUNDS_1 = "inez_settings_backgrounds_1";
/** Background Art: On */
export const SETTINGS_BACKGROUNDS_2 = "inez_settings_backgrounds_2";
/** Access Information */
export const SETTINGS_ACCESS_TITLE = "inez_settings_access_title";
/** Keyboard */
export const SETTINGS_KEYBOARD_HOVER = "inez_settings_keyboard_hover";
/** Here is information about ways to play the game with a keyboard, two switches, or head or eye tracking devices. */
export const SETTINGS_ACCESS_HELP = "inez_settings_access_help";
/** You can play the game using the arrow keys or the tab and enter keys. */
export const SETTINGS_KEYBOARD_SELECT = "inez_settings_keyboard_select";
/** Switch */
export const SETTINGS_ACCESS_SWITCH_HOVER = "inez_settings_access_switch_hover";
/** These are the controls for players who use switches.  */
export const SETTINGS_ACCESS_SWITCH_HELP = "inez_settings_access_switch_help";
/** Connect the scanning switch to the tab or space bar and the selecting switch to the enter key. */
export const SETTINGS_ACCESS_SWITCH_SELECT = "inez_settings_access_switch_select";
/** Head and Eye Gaze Devices */
export const SETTINGS_ACCESS_HEAD_HOVER = "inez_settings_access_head_hover";
/** Use the Dwell On / Dwell Off button on the top right hand side of each screen to turn the dwell feature on and off. */
export const SETTINGS_ACCESS_HEAD_SELECT = "inez_settings_access_head_select";
/** Here come the ducks. Let’s get them to Restoria safely
 */
export const FLYING_INSTRUCTIONS_1 = "inez_flying_instructions_1";
/** Oh no, there’s an obstacle. If the ducks run into it, it will make them weaker. Move the ducks to a clear lane. */
export const FLYING_ONBOARDING_1 = "inez_flying_onboarding_1";
/** To move up, use the Up button on screen or press the Up key.  */
export const FLYING_ONBOARDING_2 = "inez_flying_onboarding_2";
/** Great job dodging the [obstacle name]! */
export const FLYING_ONBOARDING_3 = "inez_flying_onboarding_3";
/** Oh no! The ducks ran into something! This will reduce their energy. */
export const FLYING_ONBOARDING_4 = "inez_flying_onboarding_4";
/** Nice dodging! [Obstacle fact] */
export const FLYING_INSTRUCTIONS_2 = "inez_flying_instructions_2";
/** Another obstacle! Let's get out of the way! */
export const FLYING_ONBOARDING_5 = "inez_flying_onboarding_5";
/** To move down, use the Down button on screen or press the Down key. */
export const FLYING_ONBOARDING_6 = "inez_flying_onboarding_6";
/** Avoid obstacles to use less energy */
export const FLYING_ONBOARDING_7 = "inez_flying_onboarding_7";
/** Watch out! */
export const FLYING_INSTRUCTIONS_3 = "inez_flying_instructions_3";
/** [Duck Name] is getting tired. Maybe another duck should take the lead. */
export const FLYING_INSTRUCTIONS_4 = "inez_flying_instructions_4";
/** Okay, let's keep going. */
export const FLYING_INSTRUCTIONS_5B = "inez_flying_instructions_5b";
/** It looks like the ducks need a rest! But which pond should they stop at? */
export const FLYING_INSTRUCTIONS_6 = "inez_flying_instructions_6";
/** Another Rest Stop! */
export const FLYING_INSTRUCTIONS_7 = "inez_flying_instructions_7";
/** Almost there! */
export const FLYING_INSTRUCTIONS_8 = "inez_flying_instructions_8";
/** We're here! The ducks are landing. */
export const FLYING_INSTRUCTIONS_9 = "inez_flying_instructions_9";
/** wind  */
export const FLYING_OBSTACLE_NAME_WIND = "inez_flying_obstacle_name_wind";
/** wind  */
export const FLYING_OBSTACLE_NAME_WIND_ALT = "inez_flying_obstacle_name_wind_alt";
/** thick cloud */
export const FLYING_OBSTACLE_NAME_FOG = "inez_flying_obstacle_name_fog";
/** a thick cloud */
export const FLYING_OBSTACLE_NAME_FOG_ALT = "inez_flying_obstacle_name_fog_alt";
/** skyscraper */
export const FLYING_OBSTACLE_NAME_SKYSCRAPER = "inez_flying_obstacle_name_skyscraper";
/** a skyscraper */
export const FLYING_OBSTACLE_NAME_SKYSCRAPER_ALT = "inez_flying_obstacle_name_skyscraper_alt";
/** street lamp */
export const FLYING_OBSTACLE_NAME_STREETLAMP = "inez_flying_obstacle_name_streetlamp";
/** a street lamp */
export const FLYING_OBSTACLE_NAME_STREETLAMP_ALT = "inez_flying_obstacle_name_streetlamp_alt";
/** gull */
export const FLYING_OBSTACLE_NAME_GULL = "inez_flying_obstacle_name_gull";
/** a gull */
export const FLYING_OBSTACLE_NAME_GULL_ALT = "inez_flying_obstacle_name_gull_alt";
/** Wind can blow the ducks off course! */
export const FLYING_OBSTACLE_FACT_WIND = "inez_flying_obstacle_fact_wind";
/** Thick clouds can confuse the ducks by blocking the stars they use to find their way at night. */
export const FLYING_OBSTACLE_FACT_FOG = "inez_flying_obstacle_fact_fog";
/** Ducks can accidentally crash into the skyscraper's windows. */
export const FLYING_OBSTACLE_FACT_SKYSCRAPER = "inez_flying_obstacle_fact_skyscraper";
/** Ducks might follow the lights instead of the stars they need to guide their way. */
export const FLYING_OBSTACLE_FACT_HIGHWAY_LAMP = "inez_flying_obstacle_fact_highway_lamp";
/** Gulls can attack the ducks, so watch out for them! */
export const FLYING_OBSTACLE_FACT_GULL = "inez_flying_obstacle_fact_gull";
/** As the ducks fly, [DUCK NAME] is the leader and the other ducks follow. */
export const AUDIO_DESCRIPTION_FLYING_INTRO_1A = "inez_audio_description_flying_intro_1a";
/**  */
export const AUDIO_DESCRIPTION_FLYING_INTRO_1B = "inez_audio_description_flying_intro_1b";
/** A bar at the top of the screen shows the flock's progress on the migration toward Restoria.  */
export const AUDIO_DESCRIPTION_FLYING_INTRO_2 = "inez_audio_description_flying_intro_2";
/** There is 1 rest stop on the way. */
export const AUDIO_DESCRIPTION_FLYING_INTRO_2B = "inez_audio_description_flying_intro_2b";
/** There are 2 rest stops on the way.  */
export const AUDIO_DESCRIPTION_FLYING_INTRO_2C = "inez_audio_description_flying_intro_2c";
/** There are 3 lanes in the cybersky that the ducks can fly in. */
export const AUDIO_DESCRIPTION_FLYING_INTRO_3 = "inez_audio_description_flying_intro_3";
/** The flock is in the top lane. */
export const AUDIO_DESCRIPTION_FLYING_LANE_TOP = "inez_audio_description_flying_lane_top";
/** The flock is in the middle lane. */
export const AUDIO_DESCRIPTION_FLYING_LANE_MIDDLE = "inez_audio_description_flying_lane_middle";
/** The flock is in the bottom lane. */
export const AUDIO_DESCRIPTION_FLYING_LANE_BOTTOM = "inez_audio_description_flying_lane_bottom";
/** [OBSTACLE] appears in the [LOCATION] lane! */
export const AUDIO_DESCRIPTION_FLYING_OBSTACLE_A = "inez_audio_description_flying_obstacle_a";
/** [OBSTACLE] appears in the [LOCATION] lane! */
export const AND = "inez_and";
/**  */
export const AUDIO_DESCRIPTION_FLYING_OBSTACLE_B = "inez_audio_description_flying_obstacle_b";
/** top */
export const AUDIO_DESCRIPTION_LANE_NAME_TOP = "inez_audio_description_lane_name_top";
/** middle */
export const AUDIO_DESCRIPTION_LANE_NAME_MIDDLE = "inez_audio_description_lane_name_middle";
/** bottom */
export const AUDIO_DESCRIPTION_LANE_NAME_BOTTOM = "inez_audio_description_lane_name_bottom";
/** Dodge obstacles by moving up or down so the ducks can reach Restoria safely! */
export const FLYING_HELP = "inez_flying_help";
/** Keep going! */
export const FLYING_KEEP_GOING_1 = "inez_flying_keep_going_1";
/** You can do it! */
export const FLYING_KEEP_GOING_2 = "inez_flying_keep_going_2";
/** We're getting closer! */
export const FLYING_KEEP_GOING_3 = "inez_flying_keep_going_3";
/** Up */
export const UP = "inez_up";
/** Down */
export const DOWN = "inez_down";
export namespace FLYING {
    /** Ellerd */
    export const DUCK_NAME_ELLERD = "inez_duck_name_ellerd";
    /** Meeka */
    export const DUCK_NAME_MEEKA = "inez_duck_name_meeka";
    /** Kevin */
    export const DUCK_NAME_KEVIN = "inez_duck_name_kevin";
    /** Michelle */
    export const DUCK_NAME_MICHELLE = "inez_duck_name_michelle";
    /** Melinda */
    export const DUCK_NAME_MELINDA = "inez_duck_name_melinda";
    /** Jiyong */
    export const DUCK_NAME_JIYONG = "inez_duck_name_jiyong";
    /** Aiden */
    export const DUCK_NAME_AIDEN = "inez_duck_name_aiden";
    /** Michael */
    export const DUCK_NAME_MICHAEL = "inez_duck_name_michael";
    /** Elliot */
    export const DUCK_NAME_ELLIOT = "inez_duck_name_elliot";
    /** Priya */
    export const DUCK_NAME_PRIYA = "inez_duck_name_priya";
    /** Diego */
    export const DUCK_NAME_DIEGO = "inez_duck_name_diego";
    /** Yolanda */
    export const DUCK_NAME_YOLANDA = "inez_duck_name_yolanda";
    /** Drake */
    export const DUCK_NAME_DRAKE = "inez_duck_name_drake";
    /** Gilberto */
    export const DUCK_NAME_GILBERTO = "inez_duck_name_gilberto";
    /** Bora */
    export const DUCK_NAME_BORA = "inez_duck_name_bora";
    /** Bob */
    export const DUCK_NAME_BOB = "inez_duck_name_bob";
    /** Rudy */
    export const DUCK_NAME_RUDY = "inez_duck_name_rudy";
    /** Squeaks */
    export const DUCK_NAME_SQUEAKS = "inez_duck_name_squeaks";
    /** Hana */
    export const DUCK_NAME_HANA = "inez_duck_name_hana";
    /** Mylo */
    export const DUCK_NAME_MYLO = "inez_duck_name_mylo";
    /** Wendy */
    export const DUCK_NAME_WENDY = "inez_duck_name_wendy";
    /** Sherry */
    export const DUCK_NAME_SHERRY = "inez_duck_name_sherry";
    /** Jay */
    export const DUCK_NAME_JAY = "inez_duck_name_jay";
    /** Sacha */
    export const DUCK_NAME_SACHA = "inez_duck_name_sacha";
    /** Soho */
    export const DUCK_NAME_SOHO = "inez_duck_name_soho";
}
/** When ducks fly in a V, the duck at the front works the hardest, creating a wave of air that the ducks behind it can ride. But when the lead duck gets tired, it's time for another duck to go in front. [Duck Name] looks tired. Want to swap them for another duck with more energy? */
export const DUCK_SWAP_ONBOARDING_1A = "matt_duck_swap_onboarding_1a";
/**  */
export const DUCK_SWAP_ONBOARDING_1B = "matt_duck_swap_onboarding_1b";
/** These are the duck's energy meters, they show how much energy each duck has. */
export const DUCK_SWAP_ONBOARDING_2 = "matt_duck_swap_onboarding_2";
/** Look at the energy meters and choose a duck that has enough energy to lead the flock. */
export const DUCK_SWAP_ONBOARDING_3 = "matt_duck_swap_onboarding_3";
/** Nice pick, that duck has enough energy. */
export const DUCK_SWAP_CORRECT_ANSWER = "matt_duck_swap_correct_answer";
/** That duck has enough energy. */
export const DUCK_SWAP_CORRECT_ANSWER_TWO_ENERGY = "matt_duck_swap_ok_answer";
/** Hmm, I don't think that duck has enough energy. Let's try another one. */
export const DUCK_SWAP_WRONG_ANSWER = "matt_duck_swap_wrong_answer";
/** That duck was just in the lead and needs a rest. Let's swap in a different duck this time. */
export const DUCK_SWAP_OLD_LEAD = "inez_duck_swap_old_lead";
/** Select the check mark button to finish swapping. */
export const DUCK_SWAP_PROMPT_DONE = "matt_duck_swap_prompt_done";
/** [Duck name] doesn't have enough energy. Let's try swapping them for another duck with more energy. */
export const DUCK_SWAP_RETURN_VISIT = "matt_duck_swap_return_visit";
/** Select a duck that has enough energy to switch with the lead duck. */
export const DUCK_SWAP_IDLE = "matt_duck_swap_idle";
/** You can do it! */
export const DUCK_SWAP_IDLE2 = "matt_duck_swap_idle2";
/** Try to find the duck with the most energy! */
export const DUCK_SWAP_IDLE3 = "matt_duck_swap_idle3";
/** Swap another duck into the lead so we can keep on flying. */
export const DUCK_SWAP_IDLE4 = "matt_duck_swap_idle4";
export namespace SWAP {
    /** Ellerd */
    export const DUCK_NAME_ELLERD = "matt_duck_name_ellerd";
    /** Meeka */
    export const DUCK_NAME_MEEKA = "matt_duck_name_meeka";
    /** Kevin */
    export const DUCK_NAME_KEVIN = "matt_duck_name_kevin";
    /** Michelle */
    export const DUCK_NAME_MICHELLE = "matt_duck_name_michelle";
    /** Melinda */
    export const DUCK_NAME_MELINDA = "matt_duck_name_melinda";
    /** Jiyong */
    export const DUCK_NAME_JIYONG = "matt_duck_name_jiyong";
    /** Aiden */
    export const DUCK_NAME_AIDEN = "matt_duck_name_aiden";
    /** Michael */
    export const DUCK_NAME_MICHAEL = "matt_duck_name_michael";
    /** Elliot */
    export const DUCK_NAME_ELLIOT = "matt_duck_name_elliot";
    /** Priya */
    export const DUCK_NAME_PRIYA = "matt_duck_name_priya";
    /** Diego */
    export const DUCK_NAME_DIEGO = "matt_duck_name_diego";
    /** Yolanda */
    export const DUCK_NAME_YOLANDA = "matt_duck_name_yolanda";
    /** Drake */
    export const DUCK_NAME_DRAKE = "matt_duck_name_drake";
    /** Gilberto */
    export const DUCK_NAME_GILBERTO = "matt_duck_name_gilberto";
    /** Bora */
    export const DUCK_NAME_BORA = "matt_duck_name_bora";
    /** Bob */
    export const DUCK_NAME_BOB = "matt_duck_name_bob";
    /** Rudy */
    export const DUCK_NAME_RUDY = "matt_duck_name_rudy";
    /** Squeaks */
    export const DUCK_NAME_SQUEAKS = "matt_duck_name_squeaks";
    /** Hana */
    export const DUCK_NAME_HANA = "matt_duck_name_hana";
    /** Mylo */
    export const DUCK_NAME_MYLO = "matt_duck_name_mylo";
    /** Wendy */
    export const DUCK_NAME_WENDY = "matt_duck_name_wendy";
    /** Sherry */
    export const DUCK_NAME_SHERRY = "matt_duck_name_sherry";
    /** Jay */
    export const DUCK_NAME_JAY = "matt_duck_name_jay";
    /** Sacha */
    export const DUCK_NAME_SACHA = "matt_duck_name_sacha";
    /** Soho */
    export const DUCK_NAME_SOHO = "matt_duck_name_soho";
}
/** An energy meter below each duck shows its energy level, from [NUMBER] to [NUMBER]. */
export const SWAP_AUDIO_DESCRIPTION_1A = "matt_swap_audio_description_1a";
/**  */
export const SWAP_AUDIO_DESCRIPTION_1B = "matt_swap_audio_description_1b";
/** The lead duck [DUCK NAME] has energy level [NUMBER]. */
export const SWAP_AUDIO_DESCRIPTION_2A = "matt_swap_audio_description_2a";
/**  */
export const SWAP_AUDIO_DESCRIPTION_2B = "matt_swap_audio_description_2b";
/** Tab or space to hear each duck’s name and energy level, then press enter to select a duck to be the leader. */
export const SWAP_AUDIO_DESCRIPTION_4 = "matt_swap_audio_description_4";
/** [DUCK NAME] has energy level [NUMBER]. */
export const SWAP_AUDIO_DESCRIPTION_DUCK_HOVER = "matt_swap_audio_description_duck_hover";
/** 0 */
export const NUMBER_ZERO = "matt_number_zero";
/** 1 */
export const NUMBER_ONE = "matt_number_one";
/** 2 */
export const NUMBER_TWO = "matt_number_two";
/** 3 */
export const NUMBER_THREE = "matt_number_three";
/** 4 */
export const NUMBER_FOUR = "matt_number_four";
/** 5 */
export const NUMBER_FIVE = "matt_number_five";
/** 10 */
export const NUMBER_TEN = "matt_number_ten";
/** 15 */
export const NUMBER_FIFTEEN = "matt_number_fifteen";
/** 20 */
export const NUMBER_TWENTY = "matt_number_twenty";
/** 25 */
export const NUMBER_TWENTYFIVE = "matt_number_twentyfive";
/** 30 */
export const NUMBER_THIRTY = "matt_number_thirty";
/** 40 */
export const NUMBER_FORTY = "matt_number_forty";
/** 50 */
export const NUMBER_FIFTY = "matt_number_fifty";
/** Done */
export const DONE = "matt_done";
/** If you want, you can switch two other ducks. Tab to the first duck you'd like to swap, and press enter to select it. Then, tab to the second duck, and press enter to swap them. */
export const SWAP_AUDIO_DESCRIPTION_3_ALT = "matt_swap_audio_description_3_alt";
/** There are two ponds. Which pond should the ducks rest at? Let’s compare the amount of food and problems at each pond to help them decide. */
export const REST_STOP_ONBOARDING_1 = "jackie_rest_stop_onboarding_1";
/** This is [PondName.] Let's find all the Food here. */
export const REST_STOP_INSTRUCTION_1A = "jackie_rest_stop_instruction_1a";
/**  */
export const REST_STOP_INSTRUCTION_1B = "jackie_rest_stop_instruction_1b";
/** Select the items at the pond, or use the plus buttons at the bottom of the chart. */
export const REST_STOP_ONBOARDING_2 = "jackie_rest_stop_onboarding_2";
/** Food */
export const REST_STOP_FOOD_TITLE_HOVER = "jackie_rest_stop_food_title_hover";
/** More food will give the ducks more energy. */
export const REST_STOP_ONBOARDING_3 = "jackie_rest_stop_onboarding_3";
/** Nice work! That's all the Food at this pond */
export const REST_STOP_FOOD_TALLY_COMPLETE = "jackie_rest_stop_food_tally_complete";
/** Now let's find all the Problems at this pond.  */
export const REST_STOP_INSTRUCTION_2 = "jackie_rest_stop_instruction_2";
/** Litter, pollution, construction, car traffic, and dogs can be harmful or frightening to the ducks, and make it hard to rest. */
export const REST_STOP_PROBLEMS_FACT = "jackie_rest_stop_problems_fact";
/** Problems */
export const REST_STOP_PROBLEMS_TITLE_HOVER = "jackie_rest_stop_problems_title_hover";
/** That's all of them, great work! */
export const REST_STOP_PROBLEMS_TALLY_COMPLETE = "jackie_rest_stop_problems_tally_complete";
/** There aren't any more of those. */
export const REST_STOP_NOMORE = "jackie_rest_stop_nomore";
/** You still have more items to add to your graph. Make sure to get all of them! */
export const REST_STOP_HAVEMORE = "jackie_rest_stop_havemore";
/** All right let's look at the other pond now.  */
export const REST_STOP_POND_1_COMPLETE = "jackie_rest_stop_pond_1_complete";
/** Let's try another type of graph. Select the Pictograph button. */
export const REST_STOP_ONBOARDING_4 = "jackie_rest_stop_onboarding_4";
/** Cool, right? Pick whichever graph type you like! Bar graph or Pictograph. */
export const REST_STOP_ONBOARDING_5 = "jackie_rest_stop_onboarding_5";
/** Pictograph */
export const REST_STOP_BUTTON_PICTOGRAPH = "jackie_rest_stop_button_pictograph";
/** Bar Graph */
export const REST_STOP_BUTTON_BAR_GRAPH = "jackie_rest_stop_button_bar_graph";
/** Now it's time to choose which pond to rest at. */
export const REST_STOP_POND_2_COMPLETE = "jackie_rest_stop_pond_2_complete";
/** Let's look at the graphs for [Pond Name] and [Pond Name] side by side. Compare the information on the graphs. */
export const REST_STOP_ONBOARDING_6A = "jackie_rest_stop_onboarding_6a";
/**  */
export const REST_STOP_ONBOARDING_6B = "jackie_rest_stop_onboarding_6b";
/**  */
export const REST_STOP_ONBOARDING_6C = "jackie_rest_stop_onboarding_6c";
/** Which is the better pond for the ducks to rest at? */
export const REST_STOP_INSTRUCTION_3 = "jackie_rest_stop_instruction_3";
/** Select the picture of the pond you want to land at. */
export const REST_STOP_COMPARE_IDLE_1 = "jackie_rest_stop_compare_idle_1";
/** More food will give your ducks more energy, and fewer problems will make it easier for them to rest.  */
export const REST_STOP_COMPARE_IDLE_2 = "jackie_rest_stop_compare_idle_2";
/** Choose the pond that will make the ducks happier and select the picture to land there. */
export const REST_STOP_COMPARE_IDLE_3 = "jackie_rest_stop_compare_idle_3";
/** You got this!  Compare the food and problems at the two ponds, and pick the best one for the ducks. */
export const REST_STOP_COMPARE_IDLE_4 = "jackie_rest_stop_compare_idle_4";
/** Nice work! The ducks have more energy now.  */
export const REST_STOP_COMPLETE_CORRECT_ANSWER = "jackie_rest_stop_complete_correct_answer";
/** Hmm, I don't think that pond had enough food for all the ducks. */
export const REST_STOP_COMPLETE_WRONG_ANSWER = "jackie_rest_stop_complete_wrong_answer";
/** Let's keep flying. */
export const REST_STOP_COMPLETE = "jackie_rest_stop_complete";
/** Corn */
export const REST_STOP_FOOD_CORN = "jackie_rest_stop_food_corn";
/** Berries */
export const REST_STOP_FOOD_BERRIES = "jackie_rest_stop_food_berries";
/** Pond weed */
export const REST_STOP_FOOD_POND_WEED = "jackie_rest_stop_food_pond_weed";
/** Flower */
export const REST_STOP_FOOD_FLOWER = "jackie_rest_stop_food_flower";
/** Lily */
export const REST_STOP_FOOD_LILY = "jackie_rest_stop_food_lily";
/** Litter */
export const REST_STOP_PROBLEM_LITTER = "jackie_rest_stop_problem_litter";
/** Construction */
export const REST_STOP_PROBLEM_CONSTRUCTION = "jackie_rest_stop_problem_construction";
/** Dog */
export const REST_STOP_PROBLEM_DOG = "jackie_rest_stop_problem_dog";
/** Car Traffic */
export const REST_STOP_PROBLEM_CAR_TRAFFIC = "jackie_rest_stop_problem_car_traffic";
/** Pollution */
export const REST_STOP_PROBLEM_POLLUTION = "jackie_rest_stop_problem_pollution";
/** BugByte Pond */
export const REST_STOP_POND_NAME_1 = "jackie_rest_stop_pond_name_1";
/** Poddle Pond */
export const REST_STOP_POND_NAME_2 = "jackie_rest_stop_pond_name_2";
/** Prism Pond */
export const REST_STOP_POND_NAME_3 = "jackie_rest_stop_pond_name_3";
/** Parallini Pond */
export const REST_STOP_POND_NAME_4 = "jackie_rest_stop_pond_name_4";
/** Aquatica Pond */
export const REST_STOP_POND_NAME_5 = "jackie_rest_stop_pond_name_5";
/** Probability Pond */
export const REST_STOP_POND_NAME_6 = "jackie_rest_stop_pond_name_6";
/** Paradise Pond */
export const REST_STOP_POND_NAME_7 = "jackie_rest_stop_pond_name_7";
/** On the left, we see the Food in [Pond NAME]. On the right is a [PICTOGRAPH/BAR GRAPH] of food. */
export const REST_STOP_AUDIO_DESCRIPTION_2A = "jackie_rest_stop_audio_description_2a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_2B = "jackie_rest_stop_audio_description_2b";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_2C = "jackie_rest_stop_audio_description_2c";
/** At the bottom of the screen are two buttons: pictograph and bar graph. Tab or space to the buttons and use enter to select the type of graph you want to create. */
export const REST_STOP_AUDIO_DESCRIPTION_3 = "jackie_rest_stop_audio_description_3";
/** Count the food in [Pond NAME] by pressing the tab key until you land on a food. Press the enter key to add the item to your tally. Pressing Enter will also move you to the next item and add it to the [Pond NAME] tally. Continue pressing the Enter key until you’ve counted all the food in [Pond NAME]. */
export const REST_STOP_AUDIO_DESCRIPTION_4A = "jackie_rest_stop_audio_description_4a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_4B = "jackie_rest_stop_audio_description_4b";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_4C = "jackie_rest_stop_audio_description_4c";
/** A [FOOD/PROBLEM] icon was added to the pictograph. */
export const REST_STOP_AUDIO_DESCRIPTION_5A = "jackie_rest_stop_audio_description_5a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_5B = "jackie_rest_stop_audio_description_5b";
/** The bar above the [FOOD/PROBLEM] icon is now [NUMBER] unit[s] high. */
export const REST_STOP_AUDIO_DESCRIPTION_6A = "jackie_rest_stop_audio_description_6a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_6B = "jackie_rest_stop_audio_description_6b";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_6C = "jackie_rest_stop_audio_description_6c";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_6C_ALT = "jackie_rest_stop_audio_description_6c_alt";
/** Now, on the left, we see the problems at [Pond NAME]. On the right is a [PICTOGRAPH/BAR GRAPH] of problems. */
export const REST_STOP_AUDIO_DESCRIPTION_7A = "jackie_rest_stop_audio_description_7a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_7B = "jackie_rest_stop_audio_description_7b";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_7C = "jackie_rest_stop_audio_description_7c";
/** Count the problems in [Pond NAME] by pressing the tab key or space bar until you land on a problem. Press the enter key to add the item to your tally. Pressing Enter will also move you to the next item and add it to the [Pond NAME] tally. Continue pressing the Enter key until you’ve counted all the problems at [Pond NAME]. */
export const REST_STOP_AUDIO_DESCRIPTION_8A = "jackie_rest_stop_audio_description_8a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_8B = "jackie_rest_stop_audio_description_8b";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_8C = "jackie_rest_stop_audio_description_8c";
/** Now we see [Pond NAME] and [Pond NAME], with a [PICTOGRAPH/BAR GRAPH]  below each tallying the food and problems at each pond. */
export const REST_STOP_AUDIO_DESCRIPTION_9A = "jackie_rest_stop_audio_description_9a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_9B = "jackie_rest_stop_audio_description_9b";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_9C = "jackie_rest_stop_audio_description_9c";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_9D = "jackie_rest_stop_audio_description_9d";
/** Press the Tab button or space bar to examine the graph of each pond. Press enter to select the pond where the flock will rest. */
export const REST_STOP_AUDIO_DESCRIPTION_IDLE = "jackie_rest_stop_audio_description_idle";
/** Press enter to continue. */
export const REST_STOP_AUDIO_DESCRIPTION_CONTINUE = "jackie_rest_stop_audio_description_continue";
/** In the [Pond NAME] pictograph, pictures of food and problems represent how many of each type of item is at [Pond NAME]. */
export const REST_STOP_AUDIO_DESCRIPTION_10A = "jackie_rest_stop_audio_description_10a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_10B = "jackie_rest_stop_audio_description_10b";
/** There are [NUMBER] problems at [POND NAME] */
export const REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_PROBLEM_TALLY_UPDATED_A = "jackie_rest_stop_audio_description_pictograph_problem_tally_updated_1a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_PROBLEM_TALLY_UPDATED_B = "jackie_rest_stop_audio_description_pictograph_problem_tally_updated_1b";
/** There are [NUMBER] foods at [POND NAME] */
export const REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_FOOD_TALLY_UPDATED_A = "jackie_rest_stop_audio_description_pictograph_food_tally_updated_1a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_PICTOGRAPH_FOOD_TALLY_UPDATED_B = "jackie_rest_stop_audio_description_pictograph_food_tally_updated_1b";
/** In the [Pond NAME] bar graph, bars are shorter or taller representing how many of each type of item is at [Pond NAME]. The graph shows a range from 0 to [NUMBER]. */
export const REST_STOP_AUDIO_DESCRIPTION_11A = "jackie_rest_stop_audio_description_11a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_11B = "jackie_rest_stop_audio_description_11b";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_11C = "jackie_rest_stop_audio_description_11c";
/** Problems at [Pond NAME]: The [PROBLEM] bar is [NUMBER] units high */
export const REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_A = "jackie_rest_stop_audio_description_bargraph_problem_tally_updated_a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_B = "jackie_rest_stop_audio_description_bargraph_problem_tally_updated_b";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_C = "jackie_rest_stop_audio_description_bargraph_problem_tally_updated_c";
/** Units high (plural) */
export const REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_PROBLEM_TALLY_UPDATED_D = "jackie_rest_stop_audio_description_bargraph_problem_tally_updated_d";
/** Food at  [Pond NAME]: The [FOOD] bar is [NUMBER] units high. unit high (alt) */
export const REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_A = "jackie_rest_stop_audio_description_bargraph_food_tally_updated_a";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_B = "jackie_rest_stop_audio_description_bargraph_food_tally_updated_b";
/**  */
export const REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_C = "jackie_rest_stop_audio_description_bargraph_food_tally_updated_c";
/** Units high (plural) */
export const REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_D = "jackie_rest_stop_audio_description_bargraph_food_tally_updated_d";
/** Unit high (singular) */
export const REST_STOP_AUDIO_DESCRIPTION_BARGRAPH_FOOD_TALLY_UPDATED_D_ALT = "jackie_rest_stop_audio_description_bargraph_food_tally_updated_d_alt";
/** 1 */
export const REST_STOP_NUMBER_ZERO = "jackie_number_zero";
/** 1 */
export const REST_STOP_NUMBER_ONE = "jackie_rest_stop_number_one";
/** 2 */
export const REST_STOP_NUMBER_TWO = "jackie_rest_stop_number_two";
/** 3 */
export const REST_STOP_NUMBER_THREE = "jackie_rest_stop_number_three";
/** 4 */
export const REST_STOP_NUMBER_FOUR = "jackie_rest_stop_number_four";
/** 5 */
export const REST_STOP_NUMBER_FIVE = "jackie_number_five";
/** 6 */
export const REST_STOP_NUMBER_SIX = "jackie_number_six";
/** 7 */
export const REST_STOP_NUMBER_SEVEN = "jackie_number_seven";
/** 8 */
export const REST_STOP_NUMBER_EIGHT = "jackie_number_eight";
/** 9 */
export const REST_STOP_NUMBER_NINE = "jackie_number_nine";
/** 10 */
export const REST_STOP_NUMBER_TEN = "jackie_number_ten";
/** 11 */
export const REST_STOP_NUMBER_ELEVEN = "jackie_number_eleven";
/** 12 */
export const REST_STOP_NUMBER_TWELVE = "jackie_number_twelve";
/** Find all Food and Problems at the pond. */
export const REST_STOP_HELP_TALLY = "jackie_rest_stop_help_tally";
/** Compare the two ponds and choose which pond is the best for the ducks to rest at. */
export const REST_STOP_HELP_COMPARE = "jackie_rest_stop_help_compare";
/** Plus */
export const REST_STOP_PLUS = "jackie_rest_stop_plus";
/** Done */
export const REST_STOP_DONE = "jackie_rest_stop_done";
/** The ducks made it to Restoria! */
export const REWARD_INTRO_1 = "inez_reward_intro_1";
/** My friends and I are flying beside a river where the ducks are swimming.  */
export const REWARD_AUDIO_DESCRIPTION = "inez_reward_audio_description";
/** Thanks to you, the ducks have a safe, warm place to spend the winter, with plenty of food and water. */
export const REWARD_INTRO_2 = "inez_reward_intro_2";
/** Great flight! You earned a badge! */
export const REWARD_ONE_BADGE = "jackie_reward_one_badge";
/** Fantastic flight! You earned some badges! */
export const REWARD_MULTIPLE_BADGES = "jackie_reward_multiple_badges";
/** You didn't earn any badges this time, Play again and try to earn one next time! */
export const REWARD_NO_BADGES = "jackie_reward_no_badges";
/** Wow! */
export const BADGE_REACT_A = "inez_badge_react_a";
/** That was amazing! */
export const BADGE_REACT_B = "inez_badge_react_b";
/** Awesome! */
export const BADGE_REACT_C = "inez_badge_react_c";
/** Marvelous migration! */
export const BADGE_REACT_D = "inez_badge_react_d";
/** You earned the [badge name] badge! */
export const BADGE_REACT_2A = "matt_badge_react_2a";
/**  */
export const BADGE_REACT_2B = "matt_badge_react_2b";
/** You can play again with the same number of ducks, or play with more ducks for a more challenging flight. */
export const REWARD_IDLE = "inez_reward_idle";
/** You can play again with the same number of ducks, play with more ducks for a more challenging flight, or play with fewer ducks for a less challenging flight. */
export const REWARD_IDLE_2 = "inez_reward_idle_2";
/** You can play again with the same number of ducks, or play with fewer ducks for a less challenging flight. */
export const REWARD_IDLE_3 = "inez_reward_idle_3";
/** Play Again */
export const REWARD_PLAY_AGAIN_HOVER = "matt_reward_play_again_hover";
/** Back to Main Menu */
export const HOME_BUTTON_HOVER = "inez_home_button_hover";
/** First Flight */
export const BADGE_NAME_1 = "matt_badge_name_1";
/** Great Dodger */
export const BADGE_NAME_2 = "matt_badge_name_2";
/** Frequent Flyer */
export const BADGE_NAME_3 = "matt_badge_name_3";
/** Meet the Ducks */
export const BADGE_NAME_4 = "matt_badge_name_4";
/** Swaptastic */
export const BADGE_NAME_5 = "matt_badge_name_5";
/** Perfect Ponds */
export const BADGE_NAME_6 = "matt_badge_name_6";
/** You finished your first flight! */
export const BADGE_DESC_1 = "matt_badge_desc_1";
/** You dodged every obstacle [Duck Number]! */
export const BADGE_DESC_2 = "matt_badge_desc_2";
/** You completed [NUMBER] flights! */
export const BADGE_DESC_3A = "matt_badge_desc_3a";
/** You completed [NUMBER] flights! */
export const BADGE_DESC_3B = "matt_badge_desc_3b";
/** You met all 28 ducks! */
export const BADGE_DESC_4 = "matt_badge_desc_4";
/** You chose all the best ducks to swap! */
export const BADGE_DESC_5 = "matt_badge_desc_5";
/** You chose all the best ponds! */
export const BADGE_DESC_6 = "matt_badge_desc_6";
/** with 5 ducks */
export const DUCKNUM_5 = "matt_ducknum_5";
/** with 7 ducks */
export const DUCKNUM_7 = "matt_ducknum_7";
/** with 9 ducks */
export const DUCKNUM_9 = "matt_ducknum_9";
/** Play */
export const MAIN_MENU_PLAY_HOVER = "matt_main_menu_play_hover";
/** Training */
export const MAIN_MENU_TRAINING_HOVER = "matt_main_menu_training_hover";
/** Flight Training and Duck Swap */
export const TRAINING_MENU_FLIGHT_HOVER = "matt_training_menu_flight_hover";
/** Rest Stop Training */
export const TRAINING_REST_STOP_HOVER = "matt_training_rest_stop_hover";
/** Select between Playing the game, or Training Mode where you can practice flying with the ducks, swapping ducks, and choosing the best rest stops. */
export const MAIN_MENU_HELP = "matt_main_menu_help";
/** You can choose either Flight Training, where you practice flying with and swapping ducks, or Rest Stop Training, to practice picking the best ponds to rest at. */
export const TRAINING_MENU_HELP = "matt_training_menu_help";
/** Tab to choose to play the game again or go to training.  */
export const MAIN_MENU_AUDIO_DESCRIPTION = "matt_main_menu_audio_description";
/** Tab to choose flight training or rest stop training.  */
export const TRAINING_MENU_AUDIO_DESCRIPTION = "matt_training_menu_audio_description";
/** Play again to earn more badges! Use the buttons on screen to choose how many ducks to play with next time. */
export const RESULTS_HELP = "inez_end_help";